import React from 'react';

const Hero: React.FC = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0a0f]"
    >
      {/* Ambient grid */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      {/* Glowing orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-cyan-500/10 rounded-full blur-[100px] pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center mt-5 pt-5">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/5 mb-8">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-emerald-400 text-sm font-mono tracking-widest uppercase">
            Available for Work
          </span>
        </div>

        {/* Name */}
        <h1 className="text-6xl md:text-8xl font-black text-white leading-none tracking-tight mb-4">
          Piyush
          <br />
          <span
            className="text-transparent bg-clip-text"
            style={{
              backgroundImage: 'linear-gradient(135deg, #10b981 0%, #06b6d4 100%)',
            }}
          >
            Prajapati
          </span>
        </h1>

        {/* Role */}
        <p className="text-xl md:text-2xl font-mono text-slate-400 mb-6 tracking-wide">
          Senior Full Stack Architect | MERN | Cloud | Scalable Systems | 9.5+ Years
          {/* <span className="text-emerald-400"> · </span> */}
          {/* 9.5+ Years */}
        </p>

        {/* Tagline */}
        <p className="max-w-2xl mx-auto text-slate-400 text-lg leading-relaxed mb-10">
         I design and architect scalable, high-performance web platforms — from frontend experiences to distributed backend systems — used in real-world production environments.
        Specialized in building microservices-driven architectures, optimizing system performance, and leading end-to-end product development across multiple domains.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap gap-4 justify-center">
          <a
            href="#portfolio"
            className="px-8 py-3.5 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-black font-bold text-sm tracking-wide transition-all duration-200 hover:shadow-[0_0_30px_rgba(16,185,129,0.4)]"
          >
            View Projects
          </a>
          <a
            href="#contact"
            className="px-8 py-3.5 rounded-lg border border-slate-600 hover:border-emerald-500/60 text-slate-300 hover:text-white font-semibold text-sm tracking-wide transition-all duration-200"
          >
            Get In Touch
          </a>
          <a
            href="./assets/images/portfolio/Piyush_CV.pdf"
            target='_blank'
            className="px-8 py-3.5 rounded-lg border border-slate-700 hover:border-slate-500 text-slate-400 hover:text-slate-200 font-semibold text-sm tracking-wide transition-all duration-200"
          >
            Download CV
          </a>
        </div>

        {/* Scroll hint */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
          <span className="text-xs text-slate-500 font-mono tracking-widest uppercase"></span>
          <div className="w-px h-10 bg-gradient-to-b from-slate-500 to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
